import { StyleSheet, View } from 'react-native'
import { Player } from '@ppwr/poker'
import { Board, BoardContainer } from '../Board'
import { PlayerColumn } from './PlayerColumn'
import { observer } from 'mobx-react-lite'
import { getPlayersColumns, sortPlayerStartingByMe } from './utils'
import { useStore } from '../../../models'
import { PlayerCell } from '../PlayerCell'
import { usePlayerControl } from '../TeacherControl/TeacherControl'
import { useCallback } from 'react'

export const Table = observer(() => {
  const {
    game: { myPlayer, seatedPlayers, setPlayerUserIdForTeacher, isTeacherObservingInPrivateGame },
    session: { isTeacher }
  } = useStore()

  const { openPlayerControl } = usePlayerControl()

  const onPressOtherPlayer = useCallback(
    (player: Player) => {
      openPlayerControl(player)
      player.userId && setPlayerUserIdForTeacher(player.userId)
    },
    [openPlayerControl, setPlayerUserIdForTeacher]
  )

  const onPlayerCellPress = isTeacherObservingInPrivateGame ? onPressOtherPlayer : undefined

  const sortedPlayers = sortPlayerStartingByMe(seatedPlayers, myPlayer)
  const playersColumn = getPlayersColumns(sortedPlayers)

  return (
    <View style={{ flexDirection: 'column', flex: 1 }}>
      <View style={styles.container}>
        <View style={[styles.column, { paddingRight: 5 }]}>
          <PlayerColumn players={playersColumn.left} onPlayerCellPress={onPlayerCellPress} isTeacher={isTeacher} />
        </View>

        {/* <View style={styles.board}>
          <Board onSidePotsPress={onSidePotsPress} />
        </View> */}
        <BoardContainer />

        <View style={[styles.column, { paddingLeft: 5 }]}>
          <PlayerColumn
            right
            players={playersColumn.right}
            onPlayerCellPress={onPlayerCellPress}
            isTeacher={isTeacher}
          />
        </View>
      </View>

      {playersColumn.center[0] && (
        <View style={{ marginTop: 0, marginBottom: 20 }}>
          <PlayerCell bottom={true} player={playersColumn.center[0]} onPlayerCellPress={onPlayerCellPress} />
        </View>
      )}
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 10
  },
  board: {
    height: '95%',
    flex: 1,
    borderRadius: 100
  },
  column: {
    flex: 0.6,
    zIndex: 1,
    height: '100%'
  }
})
